import React from 'react'
import PropTypes from 'prop-types'
import SimpleMDE from 'react-simplemde-editor'
import styled from 'styled-components'
import colors from '../../../../configuration/colors'
import InputHint from '../../../typography/Input/InputHint'
import InputLabel from '../../../typography/Input/InputLabel'

const InputContainer = styled.div`
  width: 100%;
  position: relative;
`

const AsteriskSymbol = styled.span`
  color: ${colors.crimson};
  padding-left: 3px;
`

const Input = styled.input`
 width: 98% !important;
 height: 42px !important;
 padding: 0 0 0 10px !important;
 color: ${props => props.textColor ? props.textColor : colors.black};
`

const Placeholder = styled.p`
  position: absolute;
  margin: -108px 15px 0 15px;
  color: ${colors.black};
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 19px;
`

const ErrorHintSpan = styled.span`
  color: ${colors.crimson};
  font-weight: 500;
  margin-right: 5px;
`

export const TextInputComponent = ({
  title,
  placeholder,
  hintText,
  handleEnteredTextValue,
  value,
  shouldDisplayAsteriskSymbol,
  shouldBeTextarea,
  handleStartEnteringTextValue,
  textColor,
  isError,
  errorMessage,
  options
}) => {

  return (
    <InputContainer>
      <InputLabel>
        {title}
        {shouldDisplayAsteriskSymbol && <AsteriskSymbol>*</AsteriskSymbol>}
      </InputLabel>
      {shouldBeTextarea
        ? <div
          className="course-builder-input-component"
          onClick={handleStartEnteringTextValue}
          style={{borderRadius: '5px'}}
        >
          <SimpleMDE
            value={value}
            options={options}
            onChange={handleEnteredTextValue}
          />
        </div>
        : <Input
          placeholder={placeholder}
          type='text'
          name={title}
          onChange={handleEnteredTextValue}
          value={value}
          textColor={textColor}
        />
      }
      <InputHint>
        {isError && <ErrorHintSpan>{errorMessage}</ErrorHintSpan>}
        {hintText}
      </InputHint>
    </InputContainer>
  )
}

TextInputComponent.propTypes = {
  handleClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  width: PropTypes.string,
  shouldDisplayAsteriskSymbol: PropTypes.bool.isRequired,
  isError: PropTypes.bool,
  errorMessage: PropTypes.string,
  options: PropTypes.object
}

export default TextInputComponent



// WEBPACK FOOTER //
// ./src/components/modal/CreateOrEditCourseModal/InputComponents/TextInputComponent.js